import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-business-co-default-counters',
  templateUrl: './business-co-default-counters.component.html',
  styleUrls: ['./business-co-default-counters.component.css']
})
export class BusinessCoDefaultCountersComponent implements OnInit {
    businessCoNo;

    public grid?: GridOptions;

    constructor(private stateService: StateService) {
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
    }

    private loadGrid() {
        if (!!this.businessCoNo) {
            if (!this.grid) {
                this.grid = new Grid().setRememberId('w_businesscodefaultcounters_grid').setLoadDataFunction({ method: 3910, parameters: { businessco_no: this.businessCoNo } }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
